import React, { Component } from 'react'
import OtpInput from 'react-otp-input'
import constant from '../../constant';
import { onChange, validateForm } from '../../utils';

export default class EnterSecurityCode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            PIN: { name: 'PIN', value: '', error: '', isRequired: true }
        }
    }
    onSubmit = () => {
        if (validateForm(this)) {
            this.props.onSubmitPIN(this.state.PIN.value)
        }
    }
    render() {
        const { PIN } = this.state
        const { status } = this.props
        return (
            <React.Fragment>
                <div className='text-center p-4'>
                    <h5 className='pb-5'>Enter Your 6 digit Security code to acccess this page</h5>
                    <div className='d-flex justify-content-center align-items-center'>
                        <OtpInput
                            value={PIN.value}
                            onChange={(e) => onChange(this, PIN.name, e)}
                            numInputs={6}
                            className="textCenter modal-hd"
                            separator={<span> &nbsp;</span>}
                            inputStyle={{ width: "55px", padding: "3px" }}
                            containerStyle={{ justifyContent: "center" }}
                        />

                    </div>
                    <span style={{ display: 'block' }}><a href={constant.component.Settings.url + '?security-code'}>Set/Forgot PIN</a></span>
                    {status && <span style={{ display: 'block' }} className='text-danger'>{status}</span>}
                    <a href='javascript:void(0)'
                        onClick={this.onSubmit}
                        className='btnsixdigit' >Submit</a>

                </div>
            </React.Fragment>
        )
    }
}
